class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });    this.getSectionsToRender().forEach((section) => {
  const sectionElement = section.selector
    ? document.querySelector(section.selector)
    : document.getElementById(section.id);

  if (!sectionElement) return;
  sectionElement.innerHTML = this.getSectionInnerHTML(
    parsedState.sections[section.id],
    section.selector
  );
});

setTimeout(() => {
  this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  this.open();
});

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
}


customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
document.addEventListener('DOMContentLoaded', function () {

  function setupFBTDesktopSlider() {

    if (window.innerWidth < 750) return;

    /* 
      Frequently Bought Together aur Routine Products dono sections
      me arrow-slider lagana hai, isliye ab sab matching sections
      ko loop karte hain instead of sirf ek section grab karne ke.
    */

    const sections = document.querySelectorAll(
      '.cart-drawer__recommendations--secondary, .cart-drawer__recommendations--routine, .cart-drawer__offer-strip'
    );

    if (!sections.length) return;

    sections.forEach((section) => {
      if (section.classList.contains('fbt-slider-wrapper')) return;

      section.classList.add('fbt-slider-wrapper');

      /*
        Find horizontally scrollable element inside this section
      */

      const possibleSliders = [...section.querySelectorAll('*')];

      const slider = possibleSliders.find(el => {
        const style = window.getComputedStyle(el);

        return (
          el.scrollWidth > el.clientWidth + 20 &&
          (
            style.overflowX === 'auto' ||
            style.overflowX === 'scroll' ||
            style.display === 'flex'
          )
        );
      });

      if (!slider) return;

      // Anchor the arrows to the tightest wrapper around the scrollable
      // row itself (not the whole section, which also includes the
      // heading) so positioning centers correctly on the cards.
      const arrowContainer = slider.closest('.swiper') || slider.parentElement || section;
      if (window.getComputedStyle(arrowContainer).position === 'static') {
        arrowContainer.style.position = 'relative';
      }

      const arrowBaseStyle = {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: '3',
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        border: '1px solid #e0e0e0',
        background: '#fff',
        color: '#333',
        fontSize: '18px',
        lineHeight: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0 1px 5px rgba(0, 0, 0, 0.18)',
        padding: '0'
      };

      const prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'fbt-desktop-arrow prev';
      prevBtn.setAttribute('aria-label', 'Previous products');
      prevBtn.innerHTML = '&#8249;';
      // Inline styles always win over any stylesheet rule, so this
      // guarantees the overlay position regardless of what the theme's
      // own CSS does with `.fbt-desktop-arrow`.
      Object.assign(prevBtn.style, arrowBaseStyle, { left: '4px' });

      const nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'fbt-desktop-arrow next';
      nextBtn.setAttribute('aria-label', 'Next products');
      nextBtn.innerHTML = '&#8250;';
      Object.assign(nextBtn.style, arrowBaseStyle, { right: '4px' });

      arrowContainer.appendChild(prevBtn);
      arrowContainer.appendChild(nextBtn);

      prevBtn.addEventListener('click', function () {
        slider.scrollBy({
          left: -slider.clientWidth * 0.75,
          behavior: 'smooth'
        });
      });

      nextBtn.addEventListener('click', function () {
        slider.scrollBy({
          left: slider.clientWidth * 0.75,
          behavior: 'smooth'
        });
      });
    });
  }

  setupFBTDesktopSlider();

  /*
    Cart drawer AJAX se dubara render hota hai,
    isliye automatically arrows restore karenge.
  */

  const observer = new MutationObserver(function () {
    setTimeout(setupFBTDesktopSlider, 200);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /*
    Offer Strip - Apply coupon button.
    Applies the discount code to the cart via AJAX (/cart/update.js) and
    re-renders the cart drawer sections so totals refresh immediately,
    without a page reload or checkout redirect.
  */

  document.body.addEventListener('click', function (e) {
    const button = e.target.closest('[data-offer-apply-button]');
    if (!button || button.disabled) return;

    e.preventDefault();

    const code = button.getAttribute('data-discount-code');
    const card = button.closest('[data-offer-card]');
    const messageEl = card ? card.querySelector('[data-offer-message]') : null;
    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Applying...';

    if (messageEl) {
      messageEl.hidden = true;
      messageEl.textContent = '';
      messageEl.classList.remove('offer-strip__message--error', 'offer-strip__message--success');
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        discount: code,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then((res) => {
        if (!res.ok) throw new Error('Could not apply discount');
        return res.json();
      })
      .then((cart) => {
        const appliedEntry = (cart.discount_codes || []).find(
          (entry) => entry.code && entry.code.toLowerCase() === code.toLowerCase()
        );
        const isApplied = !!(appliedEntry && appliedEntry.applicable);

        if (isApplied) {
          // Re-render the cart drawer so totals reflect the newly
          // applied discount.
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(cart);
          }

          // Safety net: force this coupon's button into the "Applied"
          // state even if the freshly re-rendered markup didn't catch
          // it (e.g. line-item level discounts, or a title mismatch).
          document.querySelectorAll('[data-offer-apply-button]').forEach((btn) => {
            const btnCode = btn.getAttribute('data-discount-code') || '';
            if (btnCode.toLowerCase() === code.toLowerCase()) {
              btn.disabled = true;
              btn.textContent = 'Applied';
              const btnCard = btn.closest('[data-offer-card]');
              if (btnCard) btnCard.classList.add('is-applied');
            }
          });
        } else {
          button.disabled = false;
          button.textContent = originalText;
          if (messageEl) {
            messageEl.hidden = false;
            messageEl.textContent = 'This code is invalid or not applicable to your cart.';
            messageEl.classList.add('offer-strip__message--error');
          }
        }
      })
      .catch(() => {
        button.disabled = false;
        button.textContent = originalText;
        if (messageEl) {
          messageEl.hidden = false;
          messageEl.textContent = 'Something went wrong. Please try again.';
          messageEl.classList.add('offer-strip__message--error');
        }
      });
  });

  /*
    Dynamic "Add These" + "Frequently Bought Together" recommendations.
    Fetches Shopify's public recommendations endpoint for the
    LAST-ADDED cart item's product, and swaps the cards in if real
    data comes back. If the fetch fails or returns nothing (e.g. a
    brand new product with no sales history yet), the server-rendered
    fixed-collection fallback already in the markup is left untouched.
  */

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function resizeShopifyImage(url, size) {
    if (!url) return url;
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, `_${size}$1$2`);
  }

  function getProductImageUrl(product) {
    if (product.featured_image) {
      return typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
    }
    if (product.images && product.images.length) {
      const img = product.images[0];
      return typeof img === 'string' ? img : img.src;
    }
    return '';
  }

  function formatPrice(rawPrice) {
    const amount = parseFloat(rawPrice);
    if (isNaN(amount)) return '';
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) {
      return Shopify.formatMoney(Math.round(amount * 100), Shopify.money_format);
    }
    // Fallback formatting if Shopify.formatMoney / Shopify.money_format
    // aren't available on this theme. Adjust the prefix below if your
    // store's currency isn't INR.
    return `Rs. ${amount.toFixed(2)}`;
  }

  function buildRecommendationCard(product) {
    const imageUrl = resizeShopifyImage(getProductImageUrl(product), '300x300');
    const price = formatPrice(product.price);
    const compareAt = product.compare_at_price_max || product.compare_at_price;
    const hasCompare = compareAt && parseFloat(compareAt) > parseFloat(product.price);
    const comparePrice = hasCompare ? formatPrice(compareAt) : '';
    const variantId = product.variants && product.variants.length ? product.variants[0].id : '';
    const title = escapeHtml(product.title);

    return `
      <div class="swiper-slide">
        <div class="recommendation-card">
          <a href="${product.url}" class="recommendation-link">
            <div class="fixed-image-box">
              <img class="fixed-image" src="${imageUrl}" alt="${title}" />
            </div>
          </a>
          <div class="recommendation-title">${title}</div>
          <div class="recommendation-price">
            ${hasCompare ? `<span class="price-compare">${comparePrice}</span>` : ''}
            <span class="price-final">${price}</span>
          </div>
          <button type="button" class="recommendation-button ajax-add-to-cart" data-variant-id="${variantId}">
            Add to cart
          </button>
        </div>
      </div>
    `;
  }

  function loadDynamicRecommendations() {
    const containers = document.querySelectorAll('[data-recommendations-container]');

    containers.forEach((container) => {
      const productId = container.getAttribute('data-last-product-id');
      const intent = container.getAttribute('data-intent') || 'related';
      if (!productId) return;

      const loadedKey = `${productId}:${intent}`;
      if (container.dataset.loadedKey === loadedKey) return;

      const track = container.querySelector('[data-recommendations-track]');
      if (!track) return;

      fetch(
        `/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=10&intent=${encodeURIComponent(intent)}`,
        { headers: { Accept: 'application/json' } }
      )
        .then((res) => {
          if (!res.ok) throw new Error('Recommendations request failed');
          return res.json();
        })
        .then((data) => {
          const products = data && data.products ? data.products : [];
          if (!products.length) return; // keep whatever fallback is already shown

          track.innerHTML = products.map(buildRecommendationCard).join('');
          container.removeAttribute('hidden');
          container.dataset.loadedKey = loadedKey;
        })
        .catch(() => {
          // Silently keep the existing fallback markup.
        });
    });
  }

  loadDynamicRecommendations();

  const recommendationsObserver = new MutationObserver(function () {
    setTimeout(loadDynamicRecommendations, 200);
  });

  recommendationsObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

});
